import Text9 from './Text9'
export default Text9
